import { useEffect } from 'react';
import { signinSilentCallback } from './userManager';

function SilentRenewOidc() {
	useEffect(() => {
		signinSilentCallback().catch((err) =>
			console.error('Silent Callback Error:', err)
		);
	}, []);

	return null;
}

export default SilentRenewOidc;
